import { Box, Link as MuiLink, Typography, TextField, InputAdornment, Autocomplete } from "@mui/material";
import { useQuery } from "@tanstack/react-query";
import { FaBuildingColumns, FaMagnifyingGlass, FaPlus } from "react-icons/fa6";
import { Link } from "react-router-dom";
import { getCustomers } from "../../../helpers/http_customers_requests";

export default function CustomerSelection({ handleSetCustomerId }) {

    const {
        data: customersData,
        isFetching,
    } = useQuery({
        queryKey: ['getCustomers'],
        queryFn: getCustomers,
        staleTime: 1000 * 15,
    });

    const { customers = [] } = customersData?.data ?? {};

    const currentCustomers = customers.map((obj) => ({
        value: obj.id,
        label: `${obj.complete_name} (${obj.cnpj})`,
    }));

    const handleChange = (_, values) => handleSetCustomerId(values?.value);

    return (
        <Box sx={styles.box}>
            <Box sx={styles.header}>
                <Box component={FaBuildingColumns} fontSize={'1.25rem'} />
                <Typography sx={styles.headerText}>Cliente</Typography>
            </Box>
            <Autocomplete
                disabled={isFetching}
                disablePortal
                fullWidth
                size="medium"
                onChange={handleChange}
                options={currentCustomers}
                sx={styles.autocomplete}
                renderInput={(params) => (
                    <TextField
                        size="small"
                        {...params}
                        label="Cliente"
                        InputProps={{
                            ...params.InputProps,
                            startAdornment: (
                                <InputAdornment position="start">
                                    <FaMagnifyingGlass />
                                </InputAdornment>
                            ),
                        }}
                    />
                )}
            />
            <MuiLink component={Link} to={'/cliente-cadastrar'} sx={styles.link} color="secondary" href="#" onClick={() => { }}>
                <Box component={FaPlus} />
                <Typography sx={styles.linkText}>Cadastrar novo cliente</Typography>
            </MuiLink>
        </Box>
    );
};

const styles = {
    box: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'start',
        flexDirection: 'column',
        width: '100%',
        height: '100%',
        padding: 2,
        boxSizing: "border-box",
    },
    header: {
        display: 'flex',
        justifyContent: 'start',
        alignItems: 'center',
    },
    headerText: {
        ml: '.5rem',
        fontSize: '1.25rem',
        textAlign: 'left',
    },
    autocomplete: {
        my: '1rem',
    },
    link: {
        display: 'flex',
        alignItems: 'center',
        mt: '1rem',
    },
    linkText: {
        ml: '.5rem',
    },
};